import { Label } from "reactstrap"

export default function Filters ({
  activeTab = 1,
  tabClickHandler = () => {},
  config= null,
  label="",
  className= "",
  filterType
}) {

  const clickTabHandler = (id) => {
    tabClickHandler(id, filterType)
  }

  const firstLastTabClasses = (id) => {
    let lastTabId = config[config.length - 1]['id']
    switch(id){
      case 1:
        return "filter-first-tab"
      case lastTabId:
        return "filter-last-tab"
      default: 
        return ""
    }
  }

  const findActiveTab = (id) => {
    if(activeTab === id) return "active-tab"
  }
  return(<>
  <div className={`d-flex  align-items-center ${className}`}>
    <Label className="mb-0 me-2">{label}</Label>
    <div className="d-flex">
      {
        config.map( el => (
          <div 
          className={`${firstLastTabClasses(el.id)} ${findActiveTab(el.id)} filter-tab`} 
          key={el.id} 
          onClick={(e) => clickTabHandler(el.id)}>
            {el.title}
          </div>
        ))
      }
    </div>
  </div>
  </>)
}

